/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_Job_Submitted_SuccessInputs */



/**
* | output |
* | --- |
* | "Transcription job was submitted successfully" |
*
* @param {Transcription_Job_Submitted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_job_submitted_success = /** @type {((inputs?: Transcription_Job_Submitted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_Job_Submitted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La tâche de transcription a été soumise avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Transkriptionsauftrag wurde erfolgreich übermittelt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il lavoro di trascrizione è stato inviato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание по транскрипции успешно отправлено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El trabajo de transcripción se envió correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录任务已成功提交。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写ジョブが正常に送信されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्शन कार्य सफलतापूर्वक सबमिट हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O trabalho de transcrição foi enviado com sucesso.")
	return /** @type {LocalizedString} */ ("Transcription job was submitted successfully")
});